/**
 * @fileoverview POST handler for the "/app_settings/custom_data_export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsCustomDataExportCacheKeys } from "./constants";
import type { PostAppSettingsCustomDataExportProps } from "./types";

export const postAppSettingsCustomDataExport = reactQueryMutationAdapter(
  appSettingsCustomDataExportCacheKeys,
  (props: PostAppSettingsCustomDataExportProps): Promise<void> => {
    return fetch("/app_settings/custom_data_export", "POST", props, {}, { propagateFetchRequestError: false });
  }
);
